"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tabs = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
// Used to set the first tab width and the tabs left position according to wrapper
const constants_1 = require("../constants");
const tab_1 = __importDefault(require("./tab"));
const tabs_style_1 = __importDefault(require("./tabs.style"));
const Tabs = ({ classes, tabs: rawTabs, slider, folder, centered }) => {
    const tabs = react_1.useMemo(() => rawTabs.reduce((acc, curr) => {
        acc.push({
            key: curr.key || curr.label,
            ...curr
        });
        return acc;
    }, []), [rawTabs]);
    // First tab active by default
    const [activeTab, setActiveTab] = react_1.default.useState((tabs && tabs[0].key) || '');
    const [sliderDimensions, setSliderDimensions] = react_1.default.useState({
        left: 0,
        width: 0
    });
    // Individual ref to get first width
    const tabRef = react_1.default.useRef(null);
    // Wrapper ref to get left position value
    const wrapperRef = react_1.default.useRef(null);
    react_1.default.useEffect(() => {
        if (slider) {
            setSliderDimensions({
                left: 0,
                width: tabRef.current.offsetWidth - constants_1.TAB_MARGIN_RIGHT
            });
        }
    }, [slider]);
    const handleClickItem = (event, key) => {
        setActiveTab(key);
        /**
         * We log the left position value of the active tab and
         * the tabs' wrapper's left position.
         * We should set it when onclick is triggered; as the user can resize its window.
         */
        const tabLeftPosition = event.currentTarget.getBoundingClientRect().left;
        const wrapperLeftPosition = wrapperRef.current.getBoundingClientRect().left;
        setSliderDimensions({
            left: tabLeftPosition - wrapperLeftPosition - constants_1.WRAPPER_PADDING_LEFT,
            width: event.currentTarget.getBoundingClientRect().width
        });
    };
    const contentWrapperProps = {
        className: classes.contentWrapper,
        'data-is-centered': centered,
        'data-has-folder': folder
    };
    return (jsx_runtime_1.jsxs(react_1.default.Fragment, { children: [jsx_runtime_1.jsxs("div", Object.assign({ ref: wrapperRef, className: classes.root, "data-has-folder": folder }, { children: [jsx_runtime_1.jsx("div", Object.assign({ className: classes.tabsWrapper }, { children: tabs.map((tab, index) => {
                            const { key, label, prefix } = tab;
                            // Need only the first ref to set the initial slider width
                            const firstTabRef = index === 0
                                ? {
                                    ref: tabRef
                                }
                                : null;
                            return (jsx_runtime_1.jsx("div", Object.assign({}, firstTabRef, { className: classes.tabsElement, "data-has-folder": folder }, { children: jsx_runtime_1.jsx(tab_1.default, { uniqueKey: key, activeTab: activeTab, label: label, onClick: handleClickItem, prefix: prefix, folder: folder }, void 0) }), key));
                        }) }), void 0),
                    slider && (jsx_runtime_1.jsx("div", { style: {
                            left: sliderDimensions.left,
                            width: sliderDimensions.width
                        }, className: classes.slider }, void 0))] }), void 0),
            jsx_runtime_1.jsx("div", Object.assign({}, contentWrapperProps, { children: Array.isArray(tabs) &&
                    tabs.map(tab => {
                        if (tab.key !== activeTab)
                            return undefined;
                        return (jsx_runtime_1.jsx(react_1.default.Fragment, { children: tab.component }, tab.key));
                    }) }), void 0)] }, void 0));
};
exports.Tabs = Tabs;
exports.Tabs.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    tabs: prop_types_1.default.arrayOf(prop_types_1.default.shape({
        prefix: prop_types_1.default.nodes,
        key: prop_types_1.default.string,
        label: prop_types_1.default.string,
        component: prop_types_1.default.nodes
    })).isRequired,
    slider: prop_types_1.default.bool,
    folder: prop_types_1.default.bool,
    centered: prop_types_1.default.bool
};
exports.Tabs.defaultProps = {
    slider: true,
    folder: false,
    centered: false
};
exports.default = react_jss_1.default(tabs_style_1.default)(exports.Tabs);
//# sourceMappingURL=index.js.map